import { Store } from '@ngrx/store';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

// Rxjs
import { Observable } from 'rxjs/Observable';

// States
import * as fromProject from '../../../project/reducers';

// Pipes
import { TranslatePipe } from '../../pipes/translate/translate.pipe';

@Component({
  selector: 'export-modal',
  templateUrl: './export-modal.component.html',
  styleUrls: ['./export-modal.component.scss']
})
export class ExportModalComponent implements OnInit {

  // Inputs
  @Input() show: boolean = false;
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() subtitleTooltip: string = '';
  @Input() language: boolean = false;
  @Input() allLanguages: boolean = true;
  // .jpg .svg .pdf .doc .csv
  @Input() extensions: string[] = [];

  // Outputs
  @Output() onFileSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCloseModal: EventEmitter<any> = new EventEmitter<any>();

  // Private Observables
  private projectLanguages$: Observable<any[]> = this.projectStore.select(state => state.project.projectLanguages);

  // Private variables
  private allowExtensions = [
    { key: null },
    { key: '.jpg', label: 'EXPORT_MODAL.JPG', inactiveUrl: 'jpg-inactive.svg', activeUrl: 'jpg-active.svg', allowIE: false },
    { key: '.png', label: 'EXPORT_MODAL.PNG', inactiveUrl: 'png-inactive.svg', activeUrl: 'png-active.svg', allowIE: false },
    { key: '.svg', label: 'EXPORT_MODAL.SVG', inactiveUrl: 'svg-inactive.svg', activeUrl: 'svg-active.svg', allowIE: false },
    { key: '.pdf', label: 'EXPORT_MODAL.PDF', inactiveUrl: 'pdf-inactive.svg', activeUrl: 'pdf-active.svg', allowIE: false },
    { key: '.docx', label: 'EXPORT_MODAL.DOC', inactiveUrl: 'doc-inactive.svg', activeUrl: 'doc-active.svg', allowIE: false },
    { key: '.ppt', label: 'EXPORT_MODAL.PPT', inactiveUrl: 'ppt-inactive.svg', activeUrl: 'ppt-active.svg', allowIE: true },
    { key: '.csv', label: 'EXPORT_MODAL.CSV', inactiveUrl: 'csv-inactive.svg', activeUrl: 'csv-active.svg', allowIE: true },
  ];

  // Show options
  public languageTitle: string = 'EXPORT_MODAL.LANGUAGE_TITLE';
  public languageDropdown = { label: 'MY_PROJECTS.PROJECT_LIST.SHOW_FILTER.LABEL', items: [], visible: false };
  public showLangWarning: boolean = false;
  public selectedLanguage: any = null;
  public files: any[] = [];

  constructor(
    private projectStore: Store<fromProject.State>,
    private translatePipe: TranslatePipe
  ) { }

  ngOnInit() {

    // fill langs
    this.fillLangs();

    // Fill files to show
    this.fillFiles();
  }

  public onLangChange(event): void {
    this.selectedLanguage = event;
  }

  // Fill langs availables
  private fillLangs(): void {
    this.projectLanguages$.take(2).subscribe((langs: any) => {
      if (langs.length) {
        // Save all langs parsed
        langs.forEach(item => { this.languageDropdown.items.push({ key: item.lan_code, text: item.name }); });
        if (this.allLanguages){
          this.languageDropdown.items.push({ key: 'all', text: this.translatePipe.transform('EXPORT_MODAL.ALL_LANGUAGES') });
        }
        // Set language dropdown visible
        this.languageDropdown.visible = true;

        // Select languages
        this.selectedLanguage = {key: langs[0].lan_code, text: langs[0].name };
      }
    });
  }

  // Fill files to show
  private fillFiles(): void {
    this.extensions.forEach(extension => {
      let obj;

      const condition = this.allowExtensions.findIndex(ext => {
        obj = ext;
        return ext.key === extension;
      });

      if (condition >= 0) {
        let canRender = true;
        if (obj.allowIE !== undefined && (this.isIE() && !obj.allowIE)) {
           canRender = false;
        }
        if (canRender) {
          this.files.push(obj);
          obj = null;
        }
      }
    });
  }

  // file selected
  public exportFile(key): void {
    this.onFileSelected.emit({extension: key, language: this.selectedLanguage});
  }

  // on close modal
  public closeModal(): void {
    this.show = !this.show;
    this.onCloseModal.emit(false);
  }

  public isIE(): boolean {
    return  false;
    /*const ua = navigator.userAgent;
    const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

    return is_ie;*/
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/export-modal/export-modal.component.ts